import React from "react";
import { Carousel } from "@vds/carousels";

function MnCarousel({
  tileComponents, isEC
}) {
  return Array.isArray(tileComponents) && tileComponents?.length > 0 && (
    <div className={`mnCarouselContainer ${isEC ? 'carouselContainerMargin' :''}`} style={{ height: "100%", width: "100%" }}>
      <Carousel
        layout="1UP"
        peek="minimum"
        paginationDisplay="none"
        data={tileComponents}
        renderItem={data => data}
      />
    </div>
  );
}

export default MnCarousel;
